<div class="wrapper-add-new-conversation">
  <span class="text-add-new-conversation-group" *ngIf="isGroupAccountsOpen">{{'CHAT.add_user_to_group' |
    translate}}</span>
  <div class="wrapper-custom-search">
    <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
    <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange($event)"
      [placeholder]="'SEARCH.search' | translate" />
    <div (click)="resetSearch()" class="wrapper-delete-search">
      <img src="../../../assets/icons/outline/icon-close.svg" alt="">
    </div>
  </div>
  <div class="wrapper-all-people" [ngClass]="{'group': isGroupAccountsOpen}">
    <div class="wrapper-custom-checkbox" #userListContainer (scroll)="onScroll()" style="overflow-y: auto;">
      <label *ngFor="let user of users">
        <input type="checkbox" [checked]="isSelected(user.id)" (change)="toggleSelection(user.id)" />
        <div class="user-item-list">
          <div class="user-item-list-left">
            <div class="wrapper-avatar-item">
                <img *ngIf="user.profile_photo_url === null" class="img-lister"
                [src]="(user.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../../assets/images/avatar-user-expert.png' : '../../../../assets/images/avatar-user.png'"
                alt="">
              <img *ngIf="user.profile_photo_url !== null" [src]="user.profile_photo_url" alt="">
            </div>
            <div class="wrapper-name-message">
              <div class="wrapper-name">
                <span class="length-character">{{ user.name }}</span>
                <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.expert"
                     src="../../../assets/icons/fill/icon-badge.svg" alt="">
                <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.company"
                     src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
              </div>
              <span class="message length-character">{{ user.username }}</span>
            </div>
          </div>
          <div class="user-item-list-right">
            <div class="checkbox-rectangle">
              <div class="checkbox-center">
                <img src="../../../../../assets/icons/outline/icon-check.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </label>
    </div>
  </div>
  <div class="wrapper-button-add-chat">
    <button class="custom-btn custom-btn--primary" [disabled]="selectedUsersCount() === 0"
      (click)="!isGroupAccountsOpen ? createChat() : addToGroup()">
      <span *ngIf="selectedUsersCount() > 1; else singleChat">{{'CHAT.create_group_chat' | translate}}</span>
      <ng-template #singleChat>
        <span>{{!isGroupAccountsOpen ? ('CHAT.create_chat' | translate ): ('CHAT.add_user' | translate)}}</span>
      </ng-template>
    </button>
  </div>
</div>
